import * as React from 'react';
import {useTranslation} from "react-i18next";
import {data} from "../Store/Data";

interface IProps {
	category: string;
}

const SubmitButton = ({category}: IProps) => {
	const {t} = useTranslation();
	const bonus = data('bonus').asString();

	if (category === 'livecams' || bonus !== "") {
		return <button type="submit"
					   className="btn std-height">{t('Jetzt Account erstellen')}</button>
	}

	if (category === 'videos') {
		return <button type="submit"
					   className="btn std-height">{t('Gratis Video freischalten')}</button>
	}

	if (category === 'chatting') {
		return <button type="submit"
					   className="btn std-height">{t('Jetzt Chat starten')}</button>
	}

	return null;
};

export default SubmitButton
